import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/postType", {
    params,
  });

const get = (id) => authApi.get(`/postType/${id}`);

const create = ({
  title,
  titleTC,
  titleSC,
  slug,
  slugTC,
  slugSC,
  category,
  categoryTC,
  categorySC,
  subCategory,
  subCategoryTC,
  subCategorySC,
  description,
  descriptionTC,
  descriptionSC,
  isSendPushNotification,
  css,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
}) =>
  authApi.post(`/postType`, {
    title,
    titleTC,
    titleSC,
    slug,
    slugTC,
    slugSC,
    category,
    categoryTC,
    categorySC,
    subCategory,
    subCategoryTC,
    subCategorySC,
    description,
    descriptionTC,
    descriptionSC,
    isSendPushNotification,
    css,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
  });

const update = ({
  id,
  title,
  titleTC,
  titleSC,
  slug,
  slugTC,
  slugSC,
  category,
  categoryTC,
  categorySC,
  subCategory,
  subCategoryTC,
  subCategorySC,
  description,
  descriptionTC,
  descriptionSC,
  isSendPushNotification,
  css,
  metaTitle,
  metaTitleTC,
  metaTitleSC,
  metaKeyword,
  metaKeywordTC,
  metaKeywordSC,
  metaDescription,
  metaDescriptionTC,
  metaDescriptionSC,
}) =>
  authApi.put(`/postType`, {
    id,
    title,
    titleTC,
    titleSC,
    slug,
    slugTC,
    slugSC,
    category,
    categoryTC,
    categorySC,
    subCategory,
    subCategoryTC,
    subCategorySC,
    description,
    descriptionTC,
    descriptionSC,
    isSendPushNotification,
    css,
    metaTitle,
    metaTitleTC,
    metaTitleSC,
    metaKeyword,
    metaKeywordTC,
    metaKeywordSC,
    metaDescription,
    metaDescriptionTC,
    metaDescriptionSC,
  });

export {
  getAll,
  get,
  create,
  update,
};
